/* @flow */
import React from 'react';
import s from './KeyReferenceDataCards.less';

type Props = {
  data: Object,
};

const KeyReferenceDataCards = (props: Props) => {

  return  (
  <div>
      <div className={`${s.sidePanelTitle}`}>
          <h2 className={`${s.summaryHeader}`}>Product Info</h2>
      </div>
      <hr className={`${s.sectionDivider}`} />
    {props.headerData.map ((fieldName, index) => {
      return (
          <div key={fieldName}>
             {Object.keys (props.boldData).includes(fieldName)?
             <h4 className={`${s.heading}`}>{fieldName} <span className={`${s.value}`}> {props.boldData[fieldName]}</span></h4>
             :< h4 className={`${s.bottomHeading}`}>{fieldName} <span className={`${s.value}`}>
             {props.plainData[fieldName]}</span></h4>}
          </div>
      );
    })}
  </div>
)
};

export default KeyReferenceDataCards;



// WEBPACK FOOTER //
// ./src/components/KeyReferenceDataCards/KeyReferenceDataCards.js